import { anchorKinds, currentInstance } from '@/heplers/index';

/**
 * Конвертирует некоторые символы в HTML Encode
 */
export function convChar(str: string): string {
  const c: { [char: string]: string } = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
  };
  return str.replace(/[<&>]/g, function (s: string) {
    return c[s];
  });
}

/**
 *  Хелпер для вытаскивания последнего элемента в fqdn (в основном для якорей в элементах). Сплиттим fqdn и вытаскиваем последний элемент оттуда
 *
 * @param str - fqdn переданный
 * @return string последний элемент
 */
export function getLastNameHelper(str: string): string {
  const splittedArray = str.split('.');
  return splittedArray[splittedArray.length - 1].replace('#', '_');
}

/**
 *  Превращаем title в anchor (Foo Bar -> foo_bar)
 */
export function convertToAnchorIdHelper(title: string): string {
  if (!title) return title;
  else return title.toLowerCase().replace(/ /g, '_');
}

/**
 *  Превращаем title в anchor (1.Foo_Bar -> 1-foo-bar)
 */
export function convertStringToAnchorIdHelper(title: string): string {
  if (!title) return title;
  const spaces = /\s+/gi;

  const useHeaderLink = (header: string): string => {
    const lowerCased = header.toLowerCase();
    return `#${lowerCased.trim().replace(spaces, '-')}`;
  };

  return useHeaderLink(title);
}

export function convertStringToAnchorIdNoHashHelper(title: string): string {
  if (!title) return title;

  const spaces = /\s+/gi;
  const unsafe = /[^\p{L}\p{N}\s\-_]|^[-]|[-]$/gu;

  const useHeaderLink = (header: string): string => {
    const lowerCased = header.toLocaleLowerCase();
    let withoutUnsafeChars = lowerCased.replace(unsafe, '');

    if (/^\d/.test(withoutUnsafeChars)) {
      withoutUnsafeChars = 'id-' + withoutUnsafeChars;
    }

    return `${withoutUnsafeChars.trim().replace(spaces, '-')}`;
  };

  return useHeaderLink(title);
}

/**
 *  Превращаем ключ в значение (kind_list -> Kind List)
 *
 * @param name имя kind (enum, property, etc.)
 * @return string значение с заглавной буквы и разделенными словами
 */
export function capitalizeNameHelper(name: string): string {
  return name.length > 1
    ? name
        .split('_')
        .map((str: string) => str.charAt(0).toUpperCase() + str.slice(1))
        .join(' ')
    : name;
}

export function parseHrefHelper(fqdn: string, beforeString = '/docs/'): string {
  if (!fqdn) return '';

  if (beforeString === '/docs/') beforeString = currentInstance === 'vox' ? '/docs/' : `/kit/docs/`;

  return beforeString + fqdn.trim().replace(/\./g, '/');
}

export function parseAdvancedHrefHelper(
  fqdn: string,
  kind: string,
  beforeString = '/docs/'
): string {
  if (!anchorKinds.includes(kind)) return parseHrefHelper(fqdn, beforeString);

  const splittedFqdn = fqdn.split('.');
  let anchor = splittedFqdn[splittedFqdn.length - 1];

  // в структурах api_field в отдельном уровне вложенности, как в остальных sdk. В остальном http_api якоря на уровень выше
  const isHttpApiField = kind === 'api_field' && !fqdn.includes('httpapi.structure');

  if (isHttpApiField) anchor = splittedFqdn[splittedFqdn.length - 2];

  return (
    parseHrefHelper(splittedFqdn.slice(0, isHttpApiField ? -2 : -1).join('.'), beforeString) +
    '#' +
    anchor
  );
}

export class TransformSdkName {
  private static sdkNames: { [sdkname: string]: string } = {
    websdk: 'Web SDK',
    iossdk: 'IOS SDK',
    http_api: 'Management API',
    voxengine: 'VoxEngine',
    androidsdk: 'Android SDK',
    androidsdk3: 'Android SDK V3 (Beta)',
    kit: 'KIT',
    reactnativesdk: 'React Native SDK',
    fluttersdk: 'Flutter SDK',
    'cti api': 'CTI API',
  };

  public static keyToTitle(sdkname: string): string {
    if (!sdkname) return;

    return this.sdkNames[sdkname] || sdkname.toLowerCase();
  }

  public static titleToKey(sdkname: string): string {
    if (!sdkname) return;

    return getKeyByValue(this.sdkNames, sdkname) || sdkname.toLowerCase();
  }
}

export function getKeyByValue(object: any, value: any): string {
  return Object.keys(object).find((key) => object[key] === value);
}
